import React from "react";
import "./Textarea.scss";

export default function Textarea({ placeholder, value, onChange, title, rows, cols }) {
  return (
    <div className="c-input-textarea">
        <label className="c-input-label">{title}</label>
        <textarea
          value={value}
          onChange={onChange}
          rows={rows}
          cols={cols}
          placeholder={placeholder}
        />
    </div>
  );
}
